export default "__VITE_ASSET__156f4039__"